var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatisfactionGlobale({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:none;stroke:#ffffff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} "), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16,
    cy: 12,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16,
    cy: 12,
    r: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "16.2,23 19.8,30.6 23.3,26.8 28.5,26.5 24.7,18.7 "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "7.3,18.8 3.7,26.5 8.8,26.8 12.3,30.6 15.9,23 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfactionGlobale);
export default __webpack_public_path__ + "static/media/satisfaction-globale.db4b4415cc6c548bc9a7343ba475be94.svg";
export { ForwardRef as ReactComponent };